import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { User, Mail, Shield, CheckCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import StaggeredAnimation from '../components/ui/staggered-animation';

const Dashboard = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      {/* Welcome Section */}
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Welcome back, {user?.name}!</h1>
          <p className="text-muted-foreground">Here's what's happening with your EnvaelSources account today.</p>
        </div>
      </StaggeredAnimation>

      {/* User Info Card */}
      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card className="max-w-2xl">
          <CardHeader>
            <CardTitle className="flex items-center space-x-2">
              <User className="h-5 w-5" />
              <span>Account Information</span>
            </CardTitle>
            <CardDescription>
              Your account details and status
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center space-x-3">
              <Mail className="h-4 w-4 text-muted-foreground" />
              <div>
                <p className="text-sm font-medium">Email</p>
                <p className="text-sm text-muted-foreground">{user?.email}</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <User className="h-4 w-4 text-muted-foreground" />
              <div>
                <p className="text-sm font-medium">Name</p>
                <p className="text-sm text-muted-foreground">{user?.name}</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <Shield className="h-4 w-4 text-muted-foreground" />
              <div>
                <p className="text-sm font-medium">Role</p>
                <p className="text-sm text-muted-foreground capitalize">{user?.role}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </StaggeredAnimation>

      {/* Success Message */}
      <StaggeredAnimation delay={300} animation="fadeUp">
        <Card className="max-w-2xl">
          <CardHeader>
            <CardTitle className="flex items-center space-x-2 text-green-600">
              <CheckCircle className="h-5 w-5" />
              <span>Authentication Successful!</span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              You have successfully logged in to your EnvaelSources account. 
              The authentication system is working perfectly with our enhanced backend!
            </p>
          </CardContent>
        </Card>
      </StaggeredAnimation>

      {/* Dashboard Content Placeholder */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <StaggeredAnimation delay={400} animation="fadeUp" stagger={0}>
          <Card className="hover-lift transition-all duration-300 ease-in-out hover:shadow-lg">
            <CardHeader>
              <CardTitle>Quick Actions</CardTitle>
              <CardDescription>Common tasks and shortcuts</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">Dashboard content will be added here...</p>
            </CardContent>
          </Card>
        </StaggeredAnimation>

        <StaggeredAnimation delay={400} animation="fadeUp" stagger={100}>
          <Card className="hover-lift transition-all duration-300 ease-in-out hover:shadow-lg">
            <CardHeader>
              <CardTitle>Recent Activity</CardTitle>
              <CardDescription>Your latest actions and updates</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">Activity feed will be displayed here...</p>
            </CardContent>
          </Card>
        </StaggeredAnimation>

        <StaggeredAnimation delay={400} animation="fadeUp" stagger={200}>
          <Card className="hover-lift transition-all duration-300 ease-in-out hover:shadow-lg">
            <CardHeader>
              <CardTitle>Statistics</CardTitle>
              <CardDescription>Key metrics and insights</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">Charts and metrics will be shown here...</p>
            </CardContent>
          </Card>
        </StaggeredAnimation>
      </div>
    </div>
  );
};

export default Dashboard;